import { seededUUIDNamespace } from "../constants/uuid";
import uuid from "uuid/v5";
import uuid4 from "uuid/v4";

export const getSubscriptionUUID = (userUUID, showUUID) =>
  uuid(userUUID + showUUID, seededUUIDNamespace);

export const isUUID = string =>
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(string);

export const newUUID = () => uuid4();
